import React from 'react';
import { Button } from '@/components/ui/button';

import type { OpenCandidatesActionFn, ProgramControlCommonProps } from '../controlTypes';

type LaiCommunityProgramControlsProps = ProgramControlCommonProps & {
  onOpenCandidatesAction: OpenCandidatesActionFn;
};

export const LaiCommunityProgramControls = ({
  values,
  onFilterChange,
  actionRowClass,
  renderStandardActionButtons,
  renderReportActionLabel,
  onOpenCandidatesAction,
}: LaiCommunityProgramControlsProps) => (
  <div className="mb-3 flex flex-wrap items-end justify-between gap-4 rounded-[var(--border-radius-medium)] border border-[var(--neutral-gray-40)] bg-white px-4 py-3">
    <div className="flex items-center gap-3">
      <div className="text-xs font-semibold uppercase tracking-wide text-[var(--neutral-gray-100)]">Facility</div>
      <div className="flex flex-wrap items-center gap-4 text-xs text-[var(--neutral-gray-120)]">
        <label className="flex items-center gap-1.5"><input type="radio" name="lai-community-facility" checked={values.laiCommunityLocationFilter === 'all'} onChange={() => onFilterChange('laiCommunityLocationFilter', 'all')} />All</label>
        <label className="flex items-center gap-1.5"><input type="radio" name="lai-community-facility" checked={values.laiCommunityLocationFilter === 'PB-PSH'} onChange={() => onFilterChange('laiCommunityLocationFilter', 'PB-PSH')} />PB-PSH</label>
        <label className="flex items-center gap-1.5"><input type="radio" name="lai-community-facility" checked={values.laiCommunityLocationFilter === 'IH+SS-PSH+BC+Other'} onChange={() => onFilterChange('laiCommunityLocationFilter', 'IH+SS-PSH+BC+Other')} />IH+SS-PSH+BC+Other</label>
      </div>
    </div>

    <div className={actionRowClass}>
      {renderStandardActionButtons()}
      <Button type="button" variant="outline" size="sm" className="h-8" onClick={() => onOpenCandidatesAction('court-list-report')}>
        {renderReportActionLabel('+ Patient List Report')}
      </Button>
    </div>
  </div>
);
